import o from"react";import{MdIcon as t}from"./MdIcon.js";import{mdiCompareHorizontal as r}from"@mdi/js";const i=({id:i="comparison",title:m="Comparison",...e})=>o.createElement(t,{id:i,title:m,path:r,...e});export{i as ComparisonIcon};
